/**
 * Devuelve las opciones de los números seleccionados con todos sus datos,
 * tomándolas de las opciones disponibles. Si un número no está entre ellas,
 * devuelve una opción que solo contiene el número.
 */
export const conservarSeleccionados = (
    numerosSeleccionados: string[],
    opcionesActuales: Record<string, any>[],
): Record<string, any>[] =>
    numerosSeleccionados.map((celular) =>
        opcionesActuales.find((opcion) => opcion.celular === celular)
        ?? { celular, label: celular, numero: celular },
    );
